import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
let reactPlugin = new ReactPlugin();

export const appInsightConfig = {
  connectionString: '',
  extensions: [reactPlugin],
  enableAutoRouteTracking: true,
  extensionConfig: {
    [reactPlugin.identifier]: { history: browserHistory },
  },
};

let appInsights;

export const initAppInsightInstance = async (config: any) => {
    appInsightConfig.connectionString = config?.connectionString;
    appInsights = await new ApplicationInsights({ config: appInsightConfig});
    appInsights.loadAppInsights();
};

export { reactPlugin, appInsights };